import { render } from "./labOrders.vue?vue&type=template&id=5913091c&scoped=true"
import script from "./labOrders.vue?vue&type=script&lang=js"
export * from "./labOrders.vue?vue&type=script&lang=js"

import "./labOrders.vue?vue&type=style&index=0&id=5913091c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5913091c"]])

export default __exports__